import { createSelector } from 'reselect';
import { isAssessmentCourse } from '../lib/courseClassification.js';

const selectCoursesListState = (state) => state.coursesList;
const selectCourseDetailState = (state) => state.courseDetail;

export const selectCourses = createSelector(selectCoursesListState, (s) => s.courses);
export const selectCoursesStatus = createSelector(selectCoursesListState, (s) => s.status);

export const selectAssessmentCourses = createSelector(selectCourses, (courses) =>
  courses.filter(isAssessmentCourse),
);
export const selectLearningCourses = createSelector(selectCourses, (courses) =>
  courses.filter((c) => !isAssessmentCourse(c)),
);

export const selectCourseDetail = selectCourseDetailState;
export const selectCourseDetailStatus = createSelector(selectCourseDetailState, (s) => s.status);

export const selectUnitsArray = createSelector(selectCourseDetailState, (s) =>
  Object.entries(s.units).map(([unitId, unit]) => ({ unitId, ...unit })),
);

export const selectCurrentUnit = createSelector(selectCourseDetailState, (s) =>
  s.currentUnitId && s.units[s.currentUnitId]
    ? { unitId: s.currentUnitId, ...s.units[s.currentUnitId] }
    : null,
);
